export default [
  {
    path: '/year-report',
    component: () => import('@/views/yearReport/2021/index.vue'),
    name: 'yearReport',
    meta: {
      title: '2021年度骑行报告',
      visibleShare: true,
      visibleAudio: false,
      auth: 0,
    },
  },
  {
    path: '/year-report-agreement',
    component: () => import('@/views/yearReport/2021/Agreement.vue'),
    name: 'yearReport-agreement',
    meta: {
      title: 'YAMAHA车辆骑行隐私协议',
      visibleAudio: false,
      auth: 0,
    },
  },
  {
    path: '/year-report-2022',
    component: () => import('@/views/yearReport/2022/Index.vue'),
    name: 'yearReport2022',
    meta: {
      backgroundClass: 'bg-yearReport2022',
      title: '2022年度骑行报告',
      visibleShare: true,
      visibleAudio: true,
      auth: 0,
    },
  },
  {
    path: '/year-report-2022-agreement',
    component: () => import('@/views/yearReport/2022/Agreement.vue'),
    name: 'yearReport2022-agreement',
    meta: {
      title: '信息授权协议及音乐版权说明',
      visibleAudio: false,
      auth: 0,
    },
  },
  {
    path: '/year-report-2024',
    component: () => import('@/views/yearReport/2024/Index.vue'),
    name: 'yearReport2024',
    meta: {
      backgroundClass: 'bg-yearReport2024',
      title: '2024年度骑行报告',
      visibleShare: true,
      visibleAudio: true,
      auth: 0,
    },
  },
  {
    path: '/year-report-2024-agreement',
    component: () => import('@/views/yearReport/2024/Agreement.vue'),
    name: 'yearReport2024-agreement',
    meta: {
      title: '信息授权协议及音乐版权说明',
      visibleAudio: false,
      auth: 0,
    },
  },
  {
    path: '/year-report-2025',
    component: () => import('@/views/yearReport/2025/Index.vue'),
    name: 'yearReport2025',
    meta: {
      backgroundClass: 'bg-yearReport2025',
      title: '2025年度骑行报告',
      visibleShare: true,
      visibleAudio: true,
      auth: 0,
    },
  },
];
